import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNTUtilsContext } from './NTUtilsContext';

type NTTableContextType = {
  redimParent: HTMLDivElement | null;
  setRedimParent: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
  isResizing: boolean;
  setIsResizing: React.Dispatch<React.SetStateAction<boolean>>;
  tableWidth: string;
  setTableWidth: React.Dispatch<React.SetStateAction<string>>;
  // Right panel expanded (left pane constrained)
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  reportType: 'report' | 'budget';
  setReportType: React.Dispatch<React.SetStateAction<'report' | 'budget'>>;
};

const NTTableContext = createContext<NTTableContextType | undefined>(undefined);
export const NTTableProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { actions } = useNTUtilsContext();
  const [redimParent, setRedimParent] = useState<HTMLDivElement | null>(null);
  const [isResizing, setIsResizing] = useState(false);
  const [tableWidth, setTableWidth] = useState(() => {
    if (!actions.detailsPanel) return '100%';
    const tableWidthFromURL = new URLSearchParams(window.location.search).get('tableWidth');
    if (tableWidthFromURL && (/^\d+(\.\d+)?px$/.test(tableWidthFromURL) || /^\d+(\.\d+)?%$/.test(tableWidthFromURL))) {
      return tableWidthFromURL;
    }
    return '68%';
  });
  const [isExpanded, setIsExpanded] = useState(false);
  const [reportType, setReportType] = useState<'report' | 'budget'>('report');

  // initialize expanded state from URL param
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('rightPanelExpanded') === '1') {
      setIsExpanded(true);
    }
  }, []);

  return (
    <NTTableContext.Provider
      value={{
        redimParent,
        setRedimParent,
        isResizing,
        setIsResizing,
        tableWidth,
        setTableWidth,
        isExpanded,
        setIsExpanded,
        reportType,
        setReportType,
      }}
    >
      {children}
    </NTTableContext.Provider>
  );
};

export const useNTTableContext = () => {
  const context = useContext(NTTableContext);
  if (!context) {
    throw new Error('useNTTableContext must be used within a NTTableProvider');
  }
  return context;
};
